module.exports = __webpack_public_path__ + "assets/img/742dd07eb3175d0800ebbc81d1847170.svg";